module.exports = __webpack_public_path__ + "img/marketing@3x.7fda65f1.png";